import { functionsService } from '../../services';
import Vue from "vue";
import { get, filter } from 'lodash'

const state = {
  list: [],
  rawList: []
};

const actions = {
  view({ dispatch, commit }, userId) {
    functionsService.view(userId)
      .then(
        functions => commit('viewSuccess', functions),
        () => {
          dispatch('alert/error', `Fehler beim Laden der Funktionsliste.`, { root: true });
        }
      );
  },

  update({ dispatch, commit }, {userId, functions}) {
    functionsService.update(userId, functions)
      .then(
        () => commit('updateSuccess'),
        () => {
          dispatch('alert/error', `Fehler beim Speichern der Funktionsliste.`, { root: true });
        }
      );
  },

  list({ dispatch, commit}, force = false) {
    if (state.rawList.length > 0 && !force) return
    functionsService.list()
      .then(
        fkts => commit('listSuccess', fkts),
        () => {
          dispatch('alert/error', `Fehler beim Laden der Funktionsliste.`, { root: true });
        }
      )
  }
};

const mutations = {
  viewSuccess(state, functions) {
    Vue.set(state, 'list', functions);
  },
  // eslint-disable-next-line no-unused-vars
  updateSuccess(state) {},
  listSuccess(state, fkts) {
    Vue.set(state, 'rawList', fkts)
  }
};

const getters = {
  funktion: state => id => {
    return get(filter(
      state.rawList, funktion => funktion.id === id
    ), '0.name', '')
  }
}

export const functions = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
